import React from 'react';
import classNames from 'classnames';
import {
  PauseFilled,
  BeakerRegular,
  BeakerFilled,
  CircleFilled,
  SubtractRegular,
  ErrorCircleRegular,
  SubtractCircleRegular,
  CheckmarkCircleRegular,
} from '@fluentui/react-icons';
import { makeStyles, tokens } from '@fluentui/react-components';

const dimensions = {
  width: '14px',
  minWidth: '14px',
  height: '20px',
  marginRight: '4px',
};

const useStyles = makeStyles({
  inactive: {
    color: tokens.colorNeutralForeground1,
    ...dimensions,
  },
  active: {
    color: tokens.colorPaletteGreenBackground3,
    ...dimensions,
  },
  error: {
    color: tokens.colorPaletteRedBackground3,
    ...dimensions,
  },
  deleted: {
    color: tokens.colorNeutralForeground4,
    ...dimensions,
  },
  enabled: {
    color: tokens.colorPaletteGreenBackground3,
    ...dimensions,
  },
});

export const StatusIcon = ({ status, isExperiment, entityType }: { status?: string; isExperiment: boolean; entityType: string; }) => {
  const styles = useStyles();

  if (!status || entityType === 'SearchTerm') {
    return null;
  }

  if (entityType === 'Account') {
    if (status === 'Errors') {
      return <ErrorCircleRegular className={classNames('account-error-icon', styles.error)} />;
    }
    if (status === 'Deleted') {
      return <SubtractCircleRegular className={classNames('account-deleted-icon', styles.deleted)} />;
    }
    if (status === 'Enabled') {
      return <CheckmarkCircleRegular className={classNames('account-enabled-icon', styles.enabled)} />;
    }
    return null;
  }

  switch (status) {
    case 'Paused':
    case 'UserPaused':
    case 'BudgetUserPaused':
    case 'Draft':
      return isExperiment ? <BeakerRegular className={classNames('paused-exp-icon', styles.inactive)} /> : <PauseFilled className={classNames('paused-icon', styles.inactive)} />;
    case 'Deleted':
      return isExperiment ? <BeakerRegular className={classNames('deleted-exp-icon', styles.inactive)} /> : <SubtractRegular className={classNames('deleted-icon', styles.inactive)} />;
    case 'Suspended':
      return isExperiment ? <BeakerRegular className={classNames('suspended-exp-icon', styles.inactive)} /> : null;
    case 'Expired':
      return <SubtractRegular className={classNames('expired-icon', styles.inactive)} />;
    default:
      return isExperiment ? <BeakerFilled className={classNames('active-exp-icon', styles.active)} /> : <CircleFilled className={classNames('active-icon', styles.active)} />;
  }
};

StatusIcon.defaultProps = {
  status: undefined,
};
